import { render, staticRenderFns } from "./treasurebox-with-overlay.vue?vue&type=template&id=8a5ab56a&scoped=true&"
import script from "./treasurebox-with-overlay.vue?vue&type=script&lang=js&"
export * from "./treasurebox-with-overlay.vue?vue&type=script&lang=js&"
import style0 from "./treasurebox-with-overlay.vue?vue&type=style&index=0&id=8a5ab56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5ab56a",
  null
  
)

export default component.exports